import { Configuration } from './configuration';
import { map } from 'rxjs';
const environmentEndpoints = {
    permissionsEndpoint: { endpoint: '/permissions/api', type: 'gatewaysUrls.content-platform' },
    // global/common endpoints
    secConfigEndpoint: { endpoint: '/feconfigs', type: 'secConfig.sec-config-url' },
    secConfigEndpointStandby: { endpoint: '/feconfigs', type: 'secConfig.sec-config-url-standby' },
    // pgo endpoints
    sendEmail: { endpoint: '/api/reports/communication/sendemail', type: 'api.email-api' },
    supplyChainApi: { endpoint: '/api/', type: 'api.supply-chain-api' },
    fulfillmentApi: { endpoint: '', type: 'api.fulfillment-api' },
    parityToolApi: { endpoint: '', type: 'api.parity-tool-api' },
    // syndication
    fileCreationApi: { endpoint: '/filecreation', type: 'api.syndication-api' },
    programsApi: { endpoint: '/programs', type: 'api.syndication-api' },
    commercialsApi: { endpoint: '/commercials', type: 'api.syndication-api' },
    graphicsApi: { endpoint: '/graphics', type: 'api.syndication-api' },
    programsETLApi: { endpoint: '/etl/programs', type: 'api.syndication-api' },
    commercialsETLApi: { endpoint: '/etl/commercials', type: 'api.syndication-api' },
    graphicsETLApi: { endpoint: '/etl/graphics', type: 'api.syndication-api' },
    templatesApi: { endpoint: '/templates', type: 'api.syndication-api' },
    schedulesApi: { endpoint: '/schedules', type: 'api.syndication-api' },
    allConfigsApi: { endpoint: '/allconfig', type: 'api.syndication-api' },
    configsApi: { endpoint: '/config', type: 'api.syndication-api' },
    accessApi: { endpoint: '/access', type: 'api.syndication-api' },
    pdfImageApi: { endpoint: '/logos', type: 'api.syndication-api' },
    omcApi: { endpoint: '', type: 'api.omc-api' },
    omcGraphqlApi: { endpoint: '', type: 'api.omc-graphql-api' },
    // Media Ingest portal
    mipGraphqlApi: { endpoint: '', type: 'api.mip-graphql-api' },
    // auth helper api
    authHelperUserTokenApi: { endpoint: '/user-token', type: 'authHelper.auth-helper-url' },
    authHelperMembersInGroupApi: { endpoint: '/members-in-group', type: 'authHelper.auth-helper-url' },
    authHelperSetUsersOidApi: { endpoint: '/oid', type: 'authHelper.auth-helper-url' },
    // auth helper api cdk
    authHelperSetUsersOidCdkApi: { endpoint: '/oid', type: 'authHelper.auth-helper-url-set-users-oid' },
    authHelperMembersInGroupCdkApi: { endpoint: '/members-in-group', type: 'authHelper.auth-helper-cdk-members-in-group-url' },
    authHelperUserTokenCdkApi: { endpoint: '/user-token', type: 'authHelper.auth-helper-cdk-user-token' },
    // central repository
    vidispineApi: { endpoint: '/', type: 'api.vidispine' },
    vidispineGatewayApi: { endpoint: '', type: 'api.vidispine-gateway' },
    fabric: { endpoint: '/discovery/', type: 'api.fabric' },
    validate: { endpoint: '/validate', type: 'api.validate' },
    slingshot: { endpoint: '/v4/position', type: 'api.slingshot' },
    triggerSegmentUpdateApi: { endpoint: '/triggerWorkflow', type: 'api.crmam-api' },
    crmamLoggingApi: { endpoint: '/api/v1/user-interactions', type: 'api.crmam-logging-api' },
    crmamLoggingApiKey: { endpoint: '', type: 'api.crmam-logging-api-key' },
    triggerReverseNotificationApi: { endpoint: '/triggerVidispineResponse', type: 'api.crmam-api' },
    crmamApiKey: { endpoint: '', type: 'api.crmam-api-key' },
    openTextApi: { endpoint: '', type: 'api.open-text-api' },
    openTextApiKey: { endpoint: '', type: 'api.opentext-api-key' },
    deleteSessionApi: { endpoint: '/deleteSession', type: 'api.crmam-api' },
    libraryManager: { endpoint: '', type: 'libraryManager' },
    segments: { endpoint: '/v4/segments', type: 'api.slingshot' },
    triggerSegmentationRequestApi: { endpoint: '/requestSegmentation', type: 'api.crmam-api' },
    getAllWfJobsDetailsApi: { endpoint: '/get-all-wf-jobs-details', type: 'api.crmam-api' },
    crmamApi: { endpoint: '/', type: 'api.crmam-api' },
    // Archive
    archiveApi: { endpoint: '/', type: 'api.archive-api' },
    archiveApiKey: { endpoint: '', type: 'archive-api.api-key' },
    // EIP 2.0 (REST-first, see apps/eip-api/AGENTS.md)
    eipApi: { endpoint: '/', type: 'api.eip-api' },
    // CRLM cart API (LibMan cart page)
    cartApi: { endpoint: '', type: 'api.cart-api' },
    cartApiKey: { endpoint: '', type: 'api.cart-api-key' },
    triggerDeliveryApi: { endpoint: '/trigger/delivery', type: 'api.archive-api' },
    opisApi: { endpoint: '', type: 'opis-api.url' },
    opisApiKey: { endpoint: '', type: 'opis-api.api-key' },
    ocApiUrl: { endpoint: '', type: 'oc-api.url' },
    ocApiKey: { endpoint: '', type: 'oc-api.api-key' },
    archiveRenditionDetails: { endpoint: '', type: 'archive' },
    archiveLoggingApi: { endpoint: '/api/v1/user-interactions', type: 'api.archive-logging-api' },
    archiveLoggingApiKey: { endpoint: '', type: 'api.archive-logging-api-key' },
    // C3 Linear Monitoring
    c3Api: { endpoint: '', type: 'api.c3-api' },
    c3Ws: { endpoint: '', type: 'api.c3-ws' },
    glimUrlPitchnew: { endpoint: '', type: 'glimUrl' },
    // Fulfillment
    fulfillmentGraphQlApi: { endpoint: '', type: 'api.fulfillment-graphql-api' },
    // Partner Console
    partnerConsoleGraphQlApi: { endpoint: '', type: 'api.partner-console-graphql-api' },
    // Library Manager
    libraryManagerGraphQlApi: { endpoint: '', type: 'api.library-manager-graphql-api' },
    crmamRenditionDetails: { endpoint: '/details', type: 'centralrepomam' },
    // Language Dictionary
    languageDictionary: { endpoint: '/languageList', type: 'api.language-dictionary' },
    // qc workbench
    qcWorkbenchGraphQlApi: { endpoint: '', type: 'api.qc-workbench-graphql-api' },
    qcWorkbenchSegmentRundown: { endpoint: '', type: 'api.qc-segmentation-rundown-api' },
    // OMC
    omcVMSRedirectUrl: { endpoint: '/WorkOrderView', type: 'vms' },
    adminConsoleEndpoint: { endpoint: '', type: 'adminConsole.user-access-api' },
    // Ragnarok endpoints
    ragnarokApi: { endpoint: '', type: 'api.ragnarok-api' },
    // Libman (Library Manager v2)
    libraryManagerV2GraphQlApi: { endpoint: '', type: 'api.library-manager-v2-graphql-api' },
    // CentralRepoMam
    contentSecurityPoliciesApi: { endpoint: '', type: 'api.content-security-policies-api' },
    // Media Hub
    mediaHubGraphQlApi: { endpoint: '', type: 'api.media-hub-graphql-api' },
    // Admin Console
    adminConsoleGraphQlApi: { endpoint: '', type: 'api.admin-console-graphql-api' },
    // VCAP UI
    vcapUI: { endpoint: '', type: 'vcap-ui.code-coverage' },
    githubTagsApi: { endpoint: '', type: 'vcap-ui.github-tags' },
    githubRunsApi: { endpoint: '', type: 'vcap-ui.github-runs' },
    githubPullsApi: { endpoint: '', type: 'vcap-ui.github-pulls' },
    githubBranchesApi: { endpoint: '', type: 'vcap-ui.github-branches' },
    githubWorkflowRunApi: { endpoint: '', type: 'vcap-ui.github-workflow-run' },
    analyticsApi: { endpoint: '', type: 'vcap-ui.analytics-api' },
    chatbot: { endpoint: '', type: 'chatbot' },
    // Release Notes UI
    releaseNotesGraphQlApi: { endpoint: '', type: 'releaseNotes.release-notes-api' },
    // Chatbot UI
    chatbotGraphQlApi: { endpoint: '', type: 'api.chatbot-graphql-api' }
};
/** When api.vidispine is localhost/empty in dev, use this so direct Vidispine calls hit the real backend. */
const VIDISPINE_DEV_FALLBACK = 'https://crmam-dev.paramountmsc.com';
function isLocalhostOrEmpty(url) {
    if (typeof url !== 'string' || !url.trim()) {
        return true;
    }
    const lower = url.toLowerCase().trim();
    return lower.includes('localhost') || lower.includes('127.0.0.1') || lower.includes('undefined');
}
export class Environments {
    static getUrl(environment) {
        const data = environmentEndpoints[environment];
        console.log('data: ', data);
        let url = Configuration.get(data.type) + data.endpoint;
        // So direct Vidispine requests (e.g. /API/collection/.../item) don't go to localhost when config is wrong
        const isLocalVidispine = environment === 'vidispineApi' &&
            typeof window !== 'undefined' &&
            (window.location?.hostname === 'localhost' || window.location?.hostname === '127.0.0.1') &&
            isLocalhostOrEmpty(url);
        if (isLocalVidispine) {
            url = VIDISPINE_DEV_FALLBACK + data.endpoint;
        }
        return url;
    }
    static getApiKey(path) {
        return Configuration.get(path);
    }
    static getUrlAsync(environment) {
        const data = environmentEndpoints[environment];
        return Configuration.getAsync(data.type).pipe(map((url) => url + data.endpoint));
    }
    static getEnvironment() {
        return Configuration.get('environment');
    }
    static getGlimURL() {
        return Configuration.get('environment');
    }
    static getEnvironmentAsync() {
        return Configuration.getAsync('environment');
    }
    static getAppUrl(name) {
        return Configuration.get(name);
    }
}
//# sourceMappingURL=environments.js.map